module.exports = "<div class=page-content> <div class=row> <div ng-include=\"'views/sidebar.html'\"></div> <div class=col-md-10> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/views/monitoring.html
// module id = 1356
// module chunks = 0